"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var rc_slider_1 = tslib_1.__importStar(require("rc-slider"));
var ConfigProvider_1 = require("../ConfigProvider");
var SliderTooltip_1 = tslib_1.__importDefault(require("./SliderTooltip"));
function Slider(props) {
    var prefix = ConfigProvider_1.usePrefix('slider');
    var _a = react_1.useState(false), hovering = _a[0], setHovering = _a[1];
    var tipFormatter = props.tipFormatter, vertical = props.vertical, handleHtmlProps = props.handleHtmlProps;
    var handleWithTooltip = react_1.useCallback(function (_a) {
        var value = _a.value, dragging = _a.dragging, restProps = tslib_1.__rest(_a, ["value", "dragging"]);
        if (tipFormatter === null) {
            return react_1.default.createElement(rc_slider_1.Handle, tslib_1.__assign({}, handleHtmlProps, restProps, { value: value }));
        }
        var visible = hovering || dragging;
        return (react_1.default.createElement(SliderTooltip_1.default, { title: tipFormatter ? tipFormatter(value) : value, visible: visible, placement: vertical ? 'right' : 'top' },
            react_1.default.createElement(rc_slider_1.Handle, tslib_1.__assign({}, handleHtmlProps, restProps, { value: value, onMouseEnter: function () { return setHovering(true); }, onMouseLeave: function () { return setHovering(false); } }))));
    }, [tipFormatter, vertical, hovering, handleHtmlProps]);
    return (react_1.default.createElement(rc_slider_1.default, tslib_1.__assign({ prefixCls: prefix, handle: handleWithTooltip }, props)));
}
exports.default = Slider;
//# sourceMappingURL=index.js.map